<template>
	<div v-if="init" class="apply-state fontSize3">
		<span class="" >
			￥<span class="fontSize1" style="margin-right: 0.052631rem;">0</span>
			<span style=" text-decoration:line-through; font-size: 0.089473rem; ">￥{{price}}</span>
		</span>

		<a class="state end bold" v-if="state == 'start'">{{stage}} 即将开始</a>
		<a @click.prevent="showQrCode" class="state ing bold" v-if="state == 'ing'">{{stage}} 火热进行中</a>
		<a class="state end bold" v-if="state == 'end'">{{stage}}
			<span v-if="report_url">试用报告已公布</span>
			<span v-else-if="selected.length">试用名单已公布</span>
			<span v-else>已结束</span>
		</a>
	</div>
</template>
<script>

import { mapState } from 'vuex'
import { EventBus } from "../event-bus.js";
export default {
  name: 'apply-state',
 /* props : {
	state : String
  },
 */
  data(){
	  return {

	  }
  },
  computed: {
  		... mapState({
			  init : 'init',
		  	  state : 'applyState',
			  count : 'count',
			  sqrCount : 'sqrCount',
			  stage : 'stage',
			  price : 'price',
			  report_url : 'report_url',
			  selected : 'selected'
		  })
  },
  created(){
	 // this.state = 'end'
	 EventBus.$on("showQrCode", ({}) => {
		 this.showQrCode();
	})
  },
  methods: {
  	showQrCode() {
		console.log('http://www.dellemc-solution.com/campaigns/try/mobile-c/#/detail/'+this.$route.params.id)
		this.$store.commit('showQrCode','http://www.dellemc-solution.com/campaigns/try/mobile-c/#/detail/'+this.$route.params.id);

  	}
  },
  components: {

  }
}
</script>

<style>
	.apply-state{
		background-image: url('./../assets/apply-state-red-bg.png');
		background-size: 100% auto;
		background-repeat: no-repeat;
		width: 2.452631rem;
		height: 0.4rem;
		    position: absolute;
		    top: -0.115789rem;
		    left: 50%;
		    margin-left: -1.226315rem;
		position: absolute;
		display: flex;
		justify-content: space-around;
		align-items: center;
		color: #fff;
	}

	.apply-state .state{
		background-size: 100% auto;
		background-repeat: no-repeat;
		width: 1.026315rem;
		height: 0.226315rem;
		text-align: center;
		line-height: 0.226315rem;
		color: #a32928;

	}

	.state.ing{
		background-image: url('./../assets/apply-state-red-ing.png');
	}

	.state.end{
		background-image: url('./../assets/apply-state-red-end.png');
	}

	.txt {
		color: #fff;
		vertical-align: middle;
	}

	.line {
		display: inline-block;
		width: 100%;
		border-top: 0.010526rem solid #fff ;
	}
</style>
